import { gql } from '@apollo/client';

export const GetS3DocumentUploadUrlQuery = gql`
  query getS3DocumentUploadUrl($bucketName: String!, $documentName: String!) {
    seller {
      s3DocumentUploadUrl(bucketName: $bucketName, documentName: $documentName)
    }
  }
`;

export const GetS3DocumentDownloadUrlQuery = gql`
  query getS3DocumentDownloadUrl($bucketName: String!, $s3Directory: String!, $ttlSeconds: Int) {
    seller {
      s3DocumentDownloadUrl(
        bucketName: $bucketName
        s3Directory: $s3Directory
        ttlSeconds: $ttlSeconds
      )
    }
  }
`;
